interface ArrowsUpWithDollarSignSVGProps {
  color: string;
  style: React.CSSProperties;
}

const ArrowsUpWithDollarSignSVG = ({
  color,
  style,
}: ArrowsUpWithDollarSignSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="49"
    height="51"
    viewBox="0 0 49 51"
    fill="none"
  >
    <g clipPath="url(#clip0_1584_46228)">
      <path
        d="M26.5875 34.144C26.5875 32.9851 25.6457 32.037 24.4948 32.037C23.3438 32.037 22.4021 32.9851 22.4021 34.144V34.9446C22.4021 35.7453 22.852 36.4722 23.5635 36.8304L25.4365 37.768C26.148 38.1262 26.5979 38.8531 26.5979 39.6538V40.4545C26.5979 41.6133 25.6562 42.5615 24.5052 42.5615C23.3543 42.5615 22.4126 41.6133 22.4126 40.4545"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M24.4949 32.037V28.8765"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M24.4949 42.572V45.7325"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M24.4948 48.893C30.8515 48.893 36.0045 43.7046 36.0045 37.3045C36.0045 30.9043 30.8515 25.7159 24.4948 25.7159C18.1382 25.7159 12.9851 30.9043 12.9851 37.3045C12.9851 43.7046 18.1382 48.893 24.4948 48.893Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M27.6338 22.5554V7.80642H30.7728L24.4948 1.48541L18.2168 7.80642H21.3558V22.5554"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M43.3289 29.93V15.1809H46.4679L40.1899 8.85992L33.9119 15.1809H37.0509V27.8229"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M11.9388 27.823V22.5554H15.0778L8.79975 16.2344L2.52173 22.5554H5.66074V37.3045"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M41 33L41 50"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M7 39.4115V49.9465"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M47.5142 20.4485V37.3045"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M47.5142 47.8395V49.9465"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M1.47534 46.786V49.9465"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M1.47534 32.037V26.7695"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M17.1704 18.3415V12.0204"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M31.8191 23.609V19.395"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M37.0508 49.9465V46.786"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M11.9387 49.9465V46.786"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1584_46228">
        <rect width="49" height="51" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default ArrowsUpWithDollarSignSVG;
